import type { Tab } from "types/tabs.types"

import { TRIGGERED_ALERTS_SEARCH_PARAMS } from "./constants"

export const getAlertsTabsConfig = (search: string): Tab[] => [
  {
    labelKey: "tabs.ALERTS",
    value: 0,
    to: { pathname: "", search: TRIGGERED_ALERTS_SEARCH_PARAMS },
  },
  {
    labelKey: "tabs.ACTIVITY",
    value: 1,
    to: { pathname: "activity", search },
  },
]
